import { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { sortBy } from 'lodash';
import { SlackChannelType, useSlackChannels } from 'hooks';
import { CbSelect } from '../CbSelect';
export interface CbSlackChannelPickerProps {
  channel: SlackChannelType | null;
  disabled?: boolean;
  onChange: (value: SlackChannelType) => void;
}
export const CbSlackChannelPicker: FC<CbSlackChannelPickerProps> = ({
  channel,
  disabled = false,
  onChange
}) => {
  const {
    channels,
    loading
  } = useSlackChannels();
  const getChannelOptions = () => {
    if (loading) return [];
    return sortBy(channels, 'name').map(({
      id,
      name
    }) => ({
      id,
      name
    }));
  };
  return <Box width="md" data-sentry-element="Box" data-sentry-component="CbSlackChannelPicker" data-sentry-source-file="CbSlackChannelPicker.tsx">
      <CbSelect disabled={disabled} getValueFromOption={channel => channel?.id} onChange={onChange} options={getChannelOptions()} placeholder={loading ? 'Loading Slack Channels' : '(Select a Channel)'} value={channel} data-sentry-element="CbSelect" data-sentry-source-file="CbSlackChannelPicker.tsx" />
    </Box>;
};